import { getCachedConfigSync, type ProductType } from '@/lib/pricing-config';

interface PricingLegendProps {
  // Pass 'flight' or 'hotel' to surface per-product math (flights = 0% markup); 'all' returns the blended default.
  scope?: ProductType;
}

export function PricingLegend({ scope = 'all' }: PricingLegendProps) {
  const config = getCachedConfigSync(scope);
  const markupPct = Math.round(config.markupPercentage * 100);
  const feePct = Math.round(config.transactionFeePercentage * 100);

  return (
    <div className="pricing-legend" role="note" aria-label="How Voy pricing works">
      <div className="pricing-legend-item">
        <span className="pricing-legend-swatch pricing-legend-swatch--standard" aria-hidden="true" />
        <span>
          Standard = supplier cost + {markupPct}% markup + {feePct}% transaction fee
        </span>
      </div>
      <div className="pricing-legend-item">
        <span className="pricing-legend-swatch pricing-legend-swatch--member" aria-hidden="true" />
        <span>
          Member = supplier cost + {feePct}% transaction fee (zero markup)
        </span>
      </div>
    </div>
  );
}
